import Hero from 'components/Hero';
import PublicGoods from 'components/PublicGoods';
import SmurfAscii from 'components/SmurfAscii';

const Home = () => {
  return (
    <main>
      <Hero />
      <SmurfAscii />
      <PublicGoods />
    </main>
  );
};

export default Home;
